import { Outlet, Navigate } from "react-router-dom";
import { useEffect } from "react";
import TwoFactorAuth from "./Pages/RestrictedPages/TwoFactorAuth";
import { EarthLoader } from "./Hooks/PageLoader";
import { useApp } from "./APIHelpers/AppContext";
import SelectAccount from "./Pages/RestrictedPages/SelectAccount";

const AllPermission = () => {
  let auth = localStorage.getItem("token");
  const { getCurrectLoginUser, organizationList, currentUserData, isDark } = useApp();
  useEffect(() => {
    if (!currentUserData) {
      getCurrectLoginUser();
    }
  }, [currentUserData, getCurrectLoginUser]);

  if (auth) {
    if (!currentUserData) {
      return <div style={{ height: "100vh" }}><EarthLoader /></div>;
    }
    if (currentUserData?.twoFA) {
      return <TwoFactorAuth currentUserData={currentUserData} isDark={isDark} />;
    }
    if (!currentUserData?.loginAccountId && currentUserData?.roleType === "organization") {
      return <SelectAccount organizationList={organizationList} currentUserData={currentUserData} getCurrectLoginUser={getCurrectLoginUser} />;
    }
    return <Outlet />;
  }

  return <Navigate to="/login" replace />;
};

const LoginPermission = () => {
  let auth = localStorage.getItem("token");
  if (!auth) {
    return <Outlet />;
  } else {
    return <Navigate to="/home" replace />;
  }
};

export const Permission = {
  LoginPermission,
  AllPermission,
};